<template>
  <div class="vue-utility-outages-wrap">
    <div>
      <b-modal
      hide-footer
      @hide="cancel"
      id="utility-outages-modal"
      :modal-class="myclass">
        <template v-slot:modal-header>
          <span class="close-x" v-on:click="cancel()">×</span>
          <h3>Utility Outages</h3>
          <!-- START select-utility-dropdown -->
          <select-utility-dropdown
          v-if="utilitesLoaded && utilites"
          :utilites="utilites"
          :utilitySelected="onUtilitySelectChange"></select-utility-dropdown>
          <!-- END select-utility-dropdown -->
        </template>
        <div
        class="modal-body-container"
        v-bind:class="{mobile: isMobile() || isTablet(), desktop: !isMobile() && !isTablet()}">
          <div class="modal-body">
            <div class="content">
              <div class="vue-outer-wrap edit-outages">
                <div
                v-if="user"
                class="controls-wrap">
                  <span
                  v-if="udateUtiityOutagesSuccessMessage"
                  v-bind:class="{fade: fadeSuccessMessage}"
                  class="success-message">&#10004;  {{udateUtiityOutagesSuccessMessage}}</span>
                  <span
                  v-if="udateUtiityOutagesErrorMessage"
                  v-bind:class="{fade: fadeErrorMessage}"
                  class="error-message">{{udateUtiityOutagesErrorMessage}}</span>
                  <span
                  v-if="totalEventsTooHigh"
                  v-bind:class="{fade: fadeErrorMessage}"
                  class="error-message">The event count is too high</span>
                  <b-spinner v-if="!utilitesLoaded && !utilites" class="ajax-spinner utilites"></b-spinner>
                  <div
                  class="header"
                  v-if="selectedUtilityName">Update {{selectedUtilityName}}</div>
                  <div
                  class="controls-container events-input"
                  v-if="utilitesLoaded && towns && towns.length">
                        <span class="col">
                          <span
                          class="total-customers-affected"><label for="towns">Total Customers Affected:</label>
                          <span class="customers">{{totalCustomersAffected}}</span></span>
                        </span>
                        <span class="col">
                          <span class="summary"><label for="towns">Total Events:</label>
                          <input
                          type="text"
                          class="events"
                          v-model="totalEvents"
                          placeholder="Total events"
                          @change="onTotalEventsChange(totalEvents)"
                          v-bind:disabled="!totalCustomersAffected || totalCustomersAffected === 0"></span>
                        </span>
                  </div>
                  <div
                  class="controls-container towns-inputs"
                  v-if="townsSortComplete && towns && towns.length">
                    <label for="towns" class="header">Update Customers Affected</label>
                    <ul class="towns">
                      <li
                      class="town"
                      :key="index"
                      v-for="(town, index) in towns"
                      v-bind:class="{hasSeverity: town.severityLevelMedium || town.severityLevelHigh}">
                        <!-- START severity icons -->
                        <span
                        class="severity-icon"
                        v-if="town.severityLevelMedium">
                        <img class="avatar" src="../../../../assets/img/severity-icon-medium.svg" alt="severity-icon-medium">
                        </span>
                        <span
                        class="severity-icon"
                        v-if="town.severityLevelHigh">
                        <img class="avatar" src="../../../../assets/img/severity-icon-high.svg" alt="severity-icon-high">
                        </span>
                        <!-- END severity icons -->
                        <label for="">{{town.name}}:</label>
                        <input v-model="town.outages" @change="onTownOutageChange(town)" type="text"  class="outages">
                      </li>
                    </ul>
                  </div>
                  <b-spinner v-if="updatingUtilityOutages" class="ajax-spinner"></b-spinner>
                  <b-button
                  class="submit"
                  v-on:click="submitOutages()"
                  v-bind:disabled="totalEventsTooHigh"
                  v-if="selectedUtilityName && !updatingUtilityOutages">Update Now</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import lodash from 'lodash';
import * as _ from 'lodash';
import API from "@/services/api";
import { Auth } from 'aws-amplify'
import vueMqMixin from "../../../shared/mixins/VueMqMixin";
import SelectUtilityDropdown from "./SelectUtilityDropdown";
import constants from "../../../../resources/constants.json";

const sortTownsDelay = 300;
const forceUpdateDelay = 500;
const FADE_MESSAGE_DELAY = 3000;
const REMOVE_MESSAGE_DELAY = 6000;
const severityLevelMedium = constants.SEVERITY_LEVEL_MEDIUM;
const severityLevelHigh = constants.SEVERITY_LEVEL_HIGH;

export default {
  name: 'UilityOutagesModal',
  mixins: [vueMqMixin],
  props: {
    hideModal: Function,
    refreshOutages: Function
  },
  components: {SelectUtilityDropdown},
  beforeCreate() {
    Auth.currentAuthenticatedUser()
      .then(user => this.user = user)
      .catch(() => console.error('user is not authenticated'));
  },
  async created() {
    this.myclass = this.isMobile() || this.isTablet() ? ['vt-outages-modal utility-outages isMobileOrTablet'] : ['vt-outages-modal utility-outages'];
    Vue.nextTick(() => this.$bvModal.show('utility-outages-modal'));
    this.loadData();
  },
  data() {
    return {
      towns: [],
      totalEvents: 0,
      totalEventsTooHigh: undefined,
      user: undefined,
      utilites: undefined,
      utilitySelected: false,
      utilitesLoaded: false,
      fadeErrorMessage: false,
      townsSortComplete: false,
      fadeSuccessMessage: false,
      totalCustomersAffected: 0,
      utilityOutagesWithTowns: [],
      updatingUtilityOutages: false,
      selectedUtilityCode: undefined,
      selectedUtilityName: undefined,
      udateUtiityOutagesErrorMessage: '',
      udateUtiityOutagesSuccessMessage: ''
    }
  },
  methods: {
    cancel() {this.hideModal() },
    stringToNumber(stringAsNumber) {return parseInt(stringAsNumber, 10) },
    normalizeTowns(){this.towns.forEach(town => town.outages = town.outages ? town.outages : 0); },
    validateTotalEvents(){
      this.totalEventsTooHigh =  this.totalEvents > this.totalCustomersAffected;
    },
    onTownOutageChange(town){
      town.outages = (town.outages && town.outages.length) ? parseInt(town.outages, 10) : 0;
      this.calculateTotalCustomersAffected();
      this.validateTotalEvents();
      this.$forceUpdate();
    },
    onTotalEventsChange(totalEvents){
      if (!totalEvents && this.totalCustomersAffected) {this.totalEvents = 1}
      this.validateTotalEvents();
      this.$forceUpdate();
    },
    getMatchingUtility(utilityCode){
      let matchingUtility = this.utilites[0];
      if (utilityCode) {matchingUtility = lodash.find(this.utilites, utility => utility.code === utilityCode); }
      return matchingUtility;
    },
    calculateTotalCustomersAffected() {
      if (!this.towns || !this.towns.length) {return; }
      this.totalCustomersAffected = _.sumBy(this.towns, 'outages');
      if (this.totalCustomersAffected === 0) {this.totalEvents = 0; }
      if (this.totalCustomersAffected > 0 && this.totalEvents === 0) {this.totalEvents = 1; }
      this.calculateTownSeverityLevels();
    },
    async loadData() {
      this.utilites = await this.getUtilites();
      this.utilityOutagesWithTowns = await this.GetOutageData();
      this.utilitesLoaded = true;

      // if the user is only authorized to edit one utilty
      if (this.utilites && this.utilites.length && this.utilites.length === 1) {
        // set selectedUtilityCode to the 1st utility.code
        const selectedUtilty = this.utilites[0];
        this.selectedUtilityCode = selectedUtilty.code;
        this.selectedUtilityName = selectedUtilty.name;
        this.setExistingTownOutages(this.selectedUtilityCode)
      }
    },
    async getUtilites() {
      let utilitesForMe = [];

      await API.GetUtilitesForMe()
        .then(utilites => utilitesForMe = utilites, err => console.log(`ERROR: getUtilites ${err}`));
      return utilitesForMe;
    },
    async GetOutageData() {
      let utilityOutagesWithTowns = [];

      await API.GetUtilityOutagesWithTowns(null, true)
      .then(outages => utilityOutagesWithTowns = outages, err => console.log(`ERROR: GetOutageData ${err}`));
      return utilityOutagesWithTowns;
    },
    submitOutages () {
      this.updatingUtilityOutages = true;
      const postData = {eventCount: this.totalEvents, townOutages: []};
      this.towns.forEach(town => postData.townOutages.push({town: town.code, outages: town.outages}));

      API.UpdateUtilityOutages(postData, this.selectedUtilityCode)
      .then(this.showSubmitSuccessUi, this.showSubmitErrorUi);
    },
    calculateTownSeverityLevels() {
      this.towns.forEach(town => {
        town.severityLevelMedium = undefined;
        town.severityLevelHigh = undefined;
        const outages = this.stringToNumber(town.outages);

        if (outages >= severityLevelMedium && outages < severityLevelHigh) {
          town.severityLevelMedium = true;
        } else if (outages >= severityLevelHigh) {
          town.severityLevelHigh = true;
        }
      });
    },
    sortTowns(){
      let noOutages = [];
      let haveOutages = [];

      this.towns.forEach(town => {
        if (!town.outages) {
          noOutages.push(town);
        } else {
          haveOutages.push(town);
        }
      });

      haveOutages.sort((a, b) => a.outages < b.outages ? 1 : -1);
      noOutages.sort((a, b) => a.name > b.name ? 1 : -1);
      this.towns = haveOutages.concat(noOutages);
      this.townsSortComplete = true;
    },
    showSubmitErrorUi(err) {
      console.error(`ERROR: UpdateUtiityOutages ${err}`);
      this.updatingUtilityOutages = false;
      this.udateUtiityOutagesErrorMessage = err.response.data.message;
      setTimeout(() => {this.fadeErrorMessage = true}, FADE_MESSAGE_DELAY);
      setTimeout(() => {
        this.udateUtiityOutagesErrorMessage = '';
        this.fadeErrorMessage = false;
      }, REMOVE_MESSAGE_DELAY);
    },
    async showSubmitSuccessUi() {
      const matchingUtility = this.getMatchingUtility(this.selectedUtilityCode);
      this.selectedUtilityName = undefined;
      this.updatingUtilityOutages = false;
      this.towns = undefined;
      this.totalEvents = undefined;
      this.udateUtiityOutagesSuccessMessage = `${matchingUtility.name} Update Succeeded`;
      this.utilityOutagesWithTowns.length = 0;
      this.loadData();
      this.refreshOutages();

      setTimeout(() => {this.fadeSuccessMessage = true}, FADE_MESSAGE_DELAY);
      setTimeout(() => {
        this.udateUtiityOutagesSuccessMessage = '';
        this.fadeSuccessMessage = false;
      }, REMOVE_MESSAGE_DELAY);
    },
    onUtilitySelectChange(utilty) {
      // if no utilty is passd in
      if (!utilty){
        // reset the ui
        this.towns = undefined;
        this.totalEvents = undefined;
        this.utilitySelected = false;
        this.selectedUtilityName = undefined;
        return;
      }

      this.townsSortComplete = false;
      this.selectedUtilityCode = utilty.code;
      this.selectedUtilityName = utilty.name;
      const matchingUtility = this.getMatchingUtility(this.selectedUtilityCode);

      if (matchingUtility.towns && matchingUtility.towns.length) {
        this.towns = matchingUtility.towns;
        this.normalizeTowns();
        setTimeout(() => this.sortTowns(), sortTownsDelay);
        setTimeout(() => this.$forceUpdate(), forceUpdateDelay);
      }

      if (this.selectedUtilityCode) {this.setExistingTownOutages(this.selectedUtilityCode); }
    },
    setExistingTownOutages(utilityCode){
      const matchingUtility = this.getMatchingUtility(utilityCode);
      if (!matchingUtility) {return; }
      const matchingUtilityOutages = lodash.find(this.utilityOutagesWithTowns, utility => utility.code === matchingUtility.code);
      this.totalEvents = matchingUtilityOutages.totalEvents;

      if (matchingUtility.towns && matchingUtility.towns.length) {
        this.towns = matchingUtility.towns;
        this.normalizeTowns();
        setTimeout(() => this.sortTowns(), sortTownsDelay);
        setTimeout(() => this.$forceUpdate(), forceUpdateDelay);
      }

      this.towns.forEach(town => {
        const matchingTown = lodash.find(matchingUtilityOutages.towns, muoTown => muoTown.townId === town.townId);
        if (matchingTown) {town.outages = this.stringToNumber(matchingTown.customerCount); }
      });

      this.calculateTotalCustomersAffected();
      this.calculateTownSeverityLevels();
      this.$forceUpdate();
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/partials/_variables.scss";

.modal-body-container{
  .vue-outer-wrap{
    padding: 0;

    .ajax-spinner{
      color: #fbd850;
    }

    .controls-wrap{
      position: relative;
      margin: 0 auto;
      background-color: #fff;

      .success-message{
        position: absolute;
        top: -3px;
        right: 160px;
        font-weight: bold;
        color: #196319;
        -webkit-transition: all 2s ease-in-out;
        -moz-transition: all 2s ease-in-out;
        -o-transition: all 2s ease-in-out;
        transition: all 2s ease-in-out;

        &.fade {
            opacity: 0;
        }
      }

      .error-message{
        position: absolute;
        top: -3px;
        right: 160px;
        display: block;
        margin-bottom: 10px;
        font-size: 18px;
        font-weight: bold;
        color: #800000;
        -webkit-transition: all 2s ease-in-out;
        -moz-transition: all 2s ease-in-out;
        -o-transition: all 2s ease-in-out;
        transition: all 2s ease-in-out;

        &.fade {
            opacity: 0;
        }
      }

      .ajax-spinner{
        &.updatingUtilityOutages{
          position: absolute;
          top: 15px;
          right: 160px;
        }

        &.utilites{
          display: block;
          width: 150px;
          height: 150px;
          margin: 50px auto 0;
        }
      }

      .submit{
        margin-top: 20px;
      }

      .header{
        margin-left: 30px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 22px;
        color: $black;
      }

      .controls-container {
        margin-bottom: 10px;
        padding: 10px 0;
        background-color: $lightGrey;

       &.events-input{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 100%;

            .col{
              display: flex;
              flex-direction: column;
              flex-basis: 100%;
              flex: 1;

              label{
                font-size: 18px;
                font-weight: $bold;
              }

              .total-customers-affected{
                margin: 0 0 0 14px;

                label{
                  width: 70%;
                }

                .customers{
                  font-weight: $xbold;
                }
              }

              .summary{
                label{
                  width: 66%;
                }

                input[type="text"]{
                  &.events{
                    width: 60px;
                    font-weight: $xbold;
                  }
                }
              }
            }
        }

        &.towns-inputs{
          background: none;

          .header{
            margin-left: 30px;
            font-weight: $xbold;
            vertical-align: middle;
            font-size: 18px;
          }

          .add-town{
            position: relative;
            left: 112px;
          }

          .towns{
            max-height: 500px;
            overflow-y: scroll;
            border-bottom: 4px solid $lightGrey;

            .town{
              position: relative;
              padding: 10px 0 5px 20px;

              &.hasSeverity{
                background-color: rgba(253, 147, 3, 0.15);
              }

              .severity-icon{
                position: absolute;
                top: 12px;
                left: 8px;

                img {
                  width: 14px;
                }
              }

              label {
                margin: 0 0 0 10px;
                width: 125px;
                font-size: 14px;
              }

              input[type="text"]{
                &.outages{
                  width: 600px;
                  border: 2px solid $modalGrey;
                }
              }
            }
          }
        }
      }
    }
  }

  &.mobile{
    .vue-outer-wrap{
      .controls-wrap{

        .header{
          margin-left: 0;
        }

        .success-message{
          position: static;
          display: block;
          margin-bottom: 10px;
          top: -0;
          right: 0;
        }

        .error-message{
          position: static;
          display: block;
          margin-bottom: 10px;
          top: -0;
          right: 0;
          color: #800000;
        }

        .controls-container {

        &.events-input{
              display: block;
              width: 100%;

              .col{
                display: block;

                label{
                  margin-right: 10px;
                }

                .total-customers-affected{
                  margin: 0;

                  label{
                    width: auto;
                  }
                }

                .summary{
                  label{
                    width: auto;
                  }

                  input[type="text"]{
                    &.events{
                      width: 60px;
                      font-weight: $xbold;
                    }
                  }
                }
              }
          }

          &.towns-inputs{
            .header{
              margin-left: 0;
            }

            .towns{
              max-height: 350px;
              .town{
                input[type="text"]{
                  &.outages{
                    width: 175px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (orientation: landscape) {
  .modal-body-container{
    &.mobile{
      .vue-outer-wrap{
        .controls-wrap{
          .controls-container {
            &.towns-inputs{
              .towns{
                max-height: 150px;
                .town{
                  input[type="text"]{
                    &.outages{
                      width: 400px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>
